import { render, staticRenderFns } from "./DetailLayer.vue?vue&type=template&id=6c8cd8cf&scoped=true&"
import script from "./DetailLayer.vue?vue&type=script&lang=js&"
export * from "./DetailLayer.vue?vue&type=script&lang=js&"
import style0 from "./DetailLayer.vue?vue&type=style&index=0&id=6c8cd8cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8cd8cf",
  null
  
)

export default component.exports